// @flow
export const createAPIEndpoints = ({ Private }: Object): Object => ({
	show: params => Private.get("teams_draft/show", params),
	show_my: params => Private.get("teams_draft/show_my", params),
	update_list: params => Private.post("teams_draft/update_list", params),
	show_list: params => Private.get("teams_draft/show_list", params),
	reset_list: params => Private.post("teams_draft/reset_list", params),
	pick_player: params => Private.post("teams_draft/pick_player", params),
	toggle_auto_pick: params =>
		Private.get("teams_draft/toggle_auto_pick", params),
	update: params => Private.post("teams_draft/update", params),
	snapshot: params => Private.get("teams_draft/snapshot", params),
	lineups: params => Private.get("teams_draft/lineups", params),
	request_waiver_trade: params =>
		Private.post("teams_draft/request_waiver_trade", params),
	make_trade: params => Private.get("teams_draft/make_trade", params),
	trades: params => Private.get("teams_draft/trades", params),
	reject_trade: params => Private.get("teams_draft/reject_trade", params),
	accept_trade: params => Private.get("teams_draft/accept_trade", params),
	remove_player: params => Private.get("teams_draft/remove_player", params),
	block_trade: params => Private.get("teams_draft/block_trade", params),
	approve_trade: params => Private.get("teams_draft/approve_trade", params),
	remove_waiver_trade: params =>
		Private.get("teams_draft/remove_waiver_trade", params),
	offer_trades: params => Private.get("teams_draft/offer_trades", params),
	manage_order_waiver_trade: params =>
		Private.post("teams_draft/manage_order_waiver_trade", params),
	select_keeper: params =>
		Private.post("teams_draft/select_keeper", params),
	remove_keeper: params =>
		Private.post("teams_draft/remove_keeper", params),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/teamDraft/index.js